import {
    EvgenEventParams,
    UseEventCallbackParams,
    UseEventCallbackParamsWithoutBuilder,
} from './create-use-event-callback';

interface UseEventCallback<
    EventType extends (...agrs: any[]) => void,
    UiParams,
    Dependencies,
    CallbackParams extends [] = []
> {
    (params: UseEventCallbackParams<EventType, UiParams, Dependencies, CallbackParams>): (
        ...callbackParams: CallbackParams
    ) => void;
}

export function createUseEventCallbackWithoutBuilder<
    EventType extends (...agrs: any[]) => void,
    Dependencies,
    CallbackParams extends [] = []
>({
    useEventCallback,
}: {
    useEventCallback: UseEventCallback<
        EventType,
        EvgenEventParams<EventType>,
        Dependencies,
        CallbackParams
    >;
}) {
    const eventParamsBuilder = ({ uiParams }: { uiParams: EvgenEventParams<EventType> }) =>
        uiParams;
    return (params: UseEventCallbackParamsWithoutBuilder<EventType, EvgenEventParams<EventType>>) =>
        useEventCallback({
            ...params,
            eventParamsBuilder,
        });
}
